// =============================================================================
// Where a Home alert pill goes, and whether it goes anywhere for this reader.
//
// A pill names a list; its tap should open THAT list (F16 UF-03). The two
// compliance pills count expired and due-in-7-days items — the Renewals tab
// lists exactly those, soonest first — but a bare /compliance landed on
// whichever tab the device last used, usually the Dashboard tab, which has no
// renewals list. Compliance already honours ?tab= (Compliance.tsx).
//
// And a tap only for someone the route gate lets in: RequireModule answers a
// refused module with <Navigate to="/"/>, so a pill linking a floor role to
// Compliance bounced them back to Home with no word. useModuleGate's answer is
// null while its reads decide — no link yet, rather than one that may refuse.
// =============================================================================

/** Compliance on the Renewals tab — the list the compliance pills count. */
export const COMPLIANCE_RENEWALS_PATH = '/compliance?tab=renewals'

/** Inspection on With PPECB — the list the "PPECB consignments awaiting
 *  result" pill counts (F16 UF-04). The pill used to open /consignments,
 *  which lists TRUCK consignments and never shows a PPECB one; Inspection's
 *  With PPECB view lists the submitted consignments with their status, and
 *  takes its view from ?view= (useUrlState in Inspection.tsx). */
export const INSPECTION_WITH_PPECB_PATH = '/inspection?view=ppecb'

/** Home's Right-now tiles open the whole list they count (F16 UF-05): Bins in
 *  yard → Yard, In coldroom → Coldroom. Active runs opens the Runs register on
 *  Active with all history (RUNS_ACTIVE_ALL_HISTORY_PATH, beside its reader in
 *  runsRegister.ts). */
export const YARD_PATH = '/yard'
export const COLDROOM_PATH = '/coldroom'

/** Where the "Coldroom aging" bar goes. It used to open bare /pallets, which
 *  cannot show age. Approved: Coldroom on Critical or worse — that needs
 *  Coldroom's ?band= reader (F05 UF-03, PR #3146, not on main yet), so until
 *  it lands this is plain Coldroom; then it becomes '/coldroom?band=critical'. */
export const COLDROOM_AGING_PATH = '/coldroom'

/** The coldroom-aging ALERT counts critical + over pallets: the Coldroom's
 *  ?band=critical focus shows exactly "Critical or worse" (F09 UF-15). */
export const COLDROOM_CRITICAL_PATH = '/coldroom?band=critical'

/** The loading-bay aging alert opens the Floor Map ringing the pallets it counts (U25 UF-09).
 *  The heat map beside it stays a bare '/loading-bay'. */
export const LOADING_BAY_PATH = '/loading-bay?focus=aging'

/** The pill's tap, only when the route gate would open the page. `null`
 *  (still deciding) and `false` both give no tap: the pill reads as text. */
export function tapIfOpenable(
  canOpen: boolean | null,
  open: () => void,
): (() => void) | undefined {
  return canOpen === true ? open : undefined
}
